<div class="signup-container d-flex align-items-center justify-content-center min-vh-100">
  <div class="signup-box">

    <div class="signup-logo text-center mb-2">
      <img src="../../../assets/images/v2/svg/logo-dark.svg" alt="Logo Trendmulti" />
    </div>

    @if (creationComplete) {
    <div class="creation-success-container text-center py-5">
      <div class="success-icon mb-4">
        <div class="icon-circle-success">
          <i class="mdi mdi-check-bold"></i>
        </div>
      </div>

      <h4 class="mb-2">{{ 'signup.home.verifyEmailTitle' | translate }}</h4>
      <p class="text-muted mb-4">
        {{ 'signup.home.verifyEmailMessageBefore' | translate }} <strong>{{ userEmail }}</strong>.
        {{ 'signup.home.verifyEmailMessageAfter' | translate }}
      </p>

      <button type="button" class="btn btn-primary d-flex align-items-center justify-content-center gap-2 mx-auto px-5"
        (click)="goToLogin()">
        <i class="mdi mdi-home"></i>
        {{ 'signup.home.goToLogin' | translate }}
      </button>

      <p class="text-muted small mt-4 mb-0">
        <i class="mdi mdi-information-outline me-1"></i>
        {{ 'signup.home.checkSpamFolder' | translate }}
      </p>
    </div>
    } @else if (isCreatingAccount) {
    <div class="creation-loading-container">
      <div class="card">
        <div class="card-body text-center py-5">
          <div class="creation-icon mb-4">
            <div class="icon-circle">
              <i class="mdi mdi-domain fs-1"></i>
            </div>
          </div>

          <h4 class="mb-2">{{ 'signup.home.configuringAccountTitle' | translate }}</h4>
          <p class="text-muted mb-4">{{ creationMessage }}</p>

          <div class="progress-container mb-3">
            <div class="progress">
              <div class="progress-bar" role="progressbar" [style.width.%]="creationProgress"
                [attr.aria-valuenow]="creationProgress" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
            <div class="text-end mt-2">
              <small class="text-muted fw-semibold">{{ creationProgress | number:'1.0-0' }}%</small>
            </div>
          </div>

          <p class="text-muted small mb-0">
            <i class="mdi mdi-information-outline me-1"></i>
            {{ 'signup.home.keepTabOpen' | translate }}
          </p>
        </div>
      </div>
    </div>
    } @else {
    <div class="text-center mb-1">
      <h4 class="mt-0">{{ 'signup.home.createAccountTitle' | translate }}</h4>
      <p class="text-muted mb-0">
        {{ 'signup.home.createAccountSubtitle' | translate }}
      </p>
    </div>

    <div class="tm-stepper col-12 mx-auto">
      <div class="steps-wrapper position-relative">
        <div class="track w-100" aria-hidden="true"></div>
        <div class="progress-line" [style.width.%]="progressPct" aria-hidden="true"></div>

        <div class="steps pt-3 d-flex flex-wrap justify-content-between mb-3 position-relative">
          @for (step of steps; track $index) {
          <div class="step d-flex align-items-center gap-2" [class.current]="$index === stepIndex()"
            [class.completed]="$index < stepIndex()" [attr.aria-current]="$index === stepIndex() ? 'step' : null"
            (click)="goToStep($index); $event.stopPropagation()">
            <div class="badge-num d-flex align-items-center justify-content-center">
              @if ($index < stepIndex()) { <i class="mdi mdi-check fw-bold" aria-hidden="true"></i>
                } @else {
                <span>{{ $index + 1 }}</span>
                }
            </div>
            <div class="text-truncate cursor-pointer">
              <div class="label text-truncate">{{ step.title }}</div>
              <small class="text-muted text-truncate d-block">{{ step.subtitle }}</small>
            </div>
          </div>
          }
        </div>
      </div>
    </div>

    <div class="card mt-3">
      <div class="card-body">
        <form [formGroup]="formGroup" (ngSubmit)="onSubmit()" novalidate>

          @if (stepIndex() === 0) {

          <div class="row">
            <div class="col-6">
              <h5 class="mb-1">{{ 'signup.home.yourDataTitle' | translate }}</h5>
              <small class="text-muted">{{ 'signup.home.yourDataSubtitle' | translate }}</small>
            </div>
            @if (!!beeviralId) {
            <div class="col-6">
              <div class="alert alert-warning border-0 rounded-0 align-right" align="right" role="alert">
                <strong>TrendPartner</strong> por <strong>{{ beeviralId }}</strong>
              </div>
            </div>
            }
          </div>

          <div class="row mt-3">
            <div class="col-12 mb-3">
              <label for="name" class="form-label fw-semibold">
                {{ 'signup.home.nameLabel' | translate }}
                <label class="text-danger">*</label>
              </label>
              <input type="text" formControlName="name" id="name" class="form-control"
                [placeholder]="'signup.home.namePlaceholder' | translate" />
              <field-error-component [field]="'name'" [label]="'signup.home.nameLabel' | translate" [formGroup]="formGroup" />
            </div>

            <div class="col-12 mb-3">
              <label for="email" class="form-label fw-semibold">
                {{ 'signup.home.emailLabel' | translate }}
                <label class="text-danger">*</label>
              </label>
              <input type="email" formControlName="email" id="email" class="form-control"
                [placeholder]="'signup.home.emailPlaceholder' | translate" />
              <field-error-component [field]="'email'" [label]="'signup.home.emailLabel' | translate" [formGroup]="formGroup" />
            </div>

            <div class="col-md-6 mb-3">
              <label for="cpf" class="form-label fw-semibold">
                {{ 'signup.home.cpfLabel' | translate }}
                <label class="text-danger">*</label>
              </label>
              <input type="text" formControlName="cpf" id="cpf" class="form-control" placeholder="000.000.000-00"
                mask="000.000.000-00" />
              <field-error-component [field]="'cpf'" [label]="'signup.home.cpfLabel' | translate" [formGroup]="formGroup" />
            </div>

            <div class="col-lg-2 mb-3">
              <label class="form-label">
                {{ 'signup.home.countryLabel' | translate }}
                <label class="text-danger">*</label>
              </label>
              <select class="form-control" (change)="onCountryChange($event)" formControlName="country">
                <option [value]="null" selected>{{ 'signup.home.selectOption' | translate }}</option>
                @for (country of countries; track $index) {
                <option [value]="country.code">
                  {{
                  selectedCountryCode === country.code
                  ? country.flag + " " + country.code
                  : country.name
                  }}
                </option>
                }
              </select>
              <field-error-component [field]="'country'" [label]="'signup.home.countryLabel' | translate" [formGroup]="formGroup" />
            </div>

            <div class="col-md-4 mb-3">
              <label for="phone" class="form-label fw-semibold">
                {{ 'signup.home.phoneLabel' | translate }}
                <label class="text-danger">*</label>
              </label>
              <input (keypress)="keyPressOnlyNumbers($event)" type="text" formControlName="phone" maxlength="15"
                id="phone" class="form-control" placeholder="000000000" [mask]="phoneMask" />
              <field-error-component [field]="'phone'" [label]="'signup.home.phoneLabel' | translate" [formGroup]="formGroup" />
            </div>
          </div>
          }

          @if (stepIndex() === 1) {
          <div class="row">
            <div class="col-6">
              <h5 class="mb-1">{{ 'signup.home.companyDataTitle' | translate }}</h5>
              <small class="text-muted">{{ 'signup.home.companyDataSubtitle' | translate }}</small>
            </div>
            @if (!!beeviralId) {
            <div class="col-6">
              <div class="alert alert-warning border-0 rounded-0 align-right" align="right" role="alert">
                <strong>TrendPartner</strong> por <strong>{{ beeviralId }}</strong>
              </div>
            </div>
            }
          </div>

          <div class="custom-switch --dropdown-fields mb-2 d-flex align-items-center gap-2">
            <div class="d-flex align-items-center">
              <input type="checkbox" id="isCompany" data-switch="success" formControlName="isCompany" tabindex="0"
                (change)="changeIsCompany()" />
              <label for="isCompany"></label>
            </div>

            @if(this.formGroup.get('isCompany')?.value) {
            <label class="custom-switch-label mb-0">
              <span>
                <h4 class="mb-1">{{ 'signup.home.registerAsCompanyTitle' | translate }}</h4>
                <small>
                  {{ 'signup.home.registerAsCompanyHint' | translate }}
                </small>
              </span>
            </label>
            } @else {
            <label class="custom-switch-label mb-0">
              <span>
                <h4 class="mb-1">{{ 'signup.home.registerAsIndividualTitle' | translate }}</h4>
                <small>
                  {{ 'signup.home.registerAsIndividualHint' | translate }}
                </small>
              </span>
            </label>
            }

          </div>

          <div class="row mt-3">
            <div class="col-12 mb-3">
              @if(this.formGroup.get('isCompany')?.value) {
              <label for="companyName" class="form-label fw-semibold">
                {{ 'signup.home.companyNameLabel' | translate }}
                <label class="text-danger">*</label>
              </label>
              <input type="text" formControlName="companyName" id="companyName" class="form-control"
                [placeholder]="'signup.home.companyNamePlaceholder' | translate" />
              <field-error-component [field]="'companyName'" [label]="'signup.home.companyLabel' | translate" [formGroup]="formGroup" />
              } @else {
              <label for="name" class="form-label fw-semibold">
                {{ 'signup.home.nameLabel' | translate }}
              </label>
              <input type="text" formControlName="name" id="name" class="form-control"
                [placeholder]="'signup.home.companyNamePlaceholder' | translate" />
              <field-error-component [field]="'name'" [label]="'signup.home.nameLabel' | translate" [formGroup]="formGroup" />
              }

            </div>

            <div class="col-md-6 mb-3">

              @if(this.formGroup.get('isCompany')?.value) {
              <label for="cnpj" class="form-label fw-semibold">
                {{ 'signup.home.cnpjLabel' | translate }}
                <label class="text-danger">*</label>
              </label>
              <input type="text" formControlName="cnpj" id="cnpj" class="form-control" placeholder="00.000.000/0000-00"
                mask="00.000.000/0000-00" />
              <field-error-component [field]="'cnpj'" [label]="'signup.home.cnpjLabel' | translate" [formGroup]="formGroup" />
              } @else {
              <label for="cnpj" class="form-label fw-semibold">
                {{ 'signup.home.cpfLabel' | translate }}
              </label>
              <input type="text" formControlName="cpf" id="cpf" class="form-control" placeholder="000.000.000-00"
                mask="000.000.000-00" />
              <field-error-component [field]="'cpf'" [label]="'signup.home.cpfLabel' | translate" [formGroup]="formGroup" />
              }
            </div>


            @if(this.formGroup.get('isCompany')?.value) {
            <div class="col-lg-3 mb-3">
              <label class="form-label">
                {{ 'signup.home.countryLabel' | translate }}
                <label class="text-danger">*</label>
              </label>
              <select class="form-control" (change)="onCompanyCountryChange($event)" formControlName="companyCountry">
                <option [value]="null" selected>{{ 'signup.home.selectOption' | translate }}</option>
                @for (country of countries; track $index) {
                <option [value]="country.code">
                  {{
                  selectedCompanyCountryCode === country.code
                  ? country.flag + " " + country.code
                  : country.name
                  }}
                </option>
                }
              </select>
              <field-error-component [field]="'companyCountry'" [label]="'signup.home.countryLabel' | translate" [formGroup]="formGroup" />
            </div>
            <div class="col-md-3 mb-3">
              <label for="companyPhone" class="form-label fw-semibold">
                {{ 'signup.home.companyPhoneLabel' | translate }}
                <label class="text-danger">*</label>
              </label>
              <input (keypress)="keyPressOnlyNumbers($event)" type="text" formControlName="companyPhone" maxlength="15"
                id="companyPhone" class="form-control" placeholder="000000000" [mask]="companyPhoneMask" />
              <field-error-component [field]="'companyPhone'" [label]="'signup.home.companyPhoneLabel' | translate" [formGroup]="formGroup" />
            </div>
            } @else {
              <div class="col-lg-3 mb-3">
                <label class="form-label">
                  {{ 'signup.home.countryLabel' | translate }}
                  <label class="text-danger">*</label>
                </label>
                <select class="form-control" (change)="onCountryChange($event)" formControlName="country">
                  <option [value]="null" selected>{{ 'signup.home.selectOption' | translate }}</option>
                  @for (country of countries; track $index) {
                  <option [value]="country.code">
                    {{
                    selectedCountryCode === country.code
                    ? country.flag + " " + country.code
                    : country.name
                    }}
                  </option>
                  }
                </select>
                <field-error-component [field]="'country'" [label]="'signup.home.countryLabel' | translate" [formGroup]="formGroup" />
              </div>
              <div class="col-md-3 mb-3">
                <label for="phone" class="form-label fw-semibold">
                  {{ 'signup.home.phoneLabel' | translate }}
                  <label class="text-danger">*</label>
                </label>
                <input (keypress)="keyPressOnlyNumbers($event)" type="text" formControlName="phone" maxlength="15"
                  id="phone" class="form-control" placeholder="(00) 00000-0000" mask="(00) 00000-0000" />
                <field-error-component [field]="'phone'" [label]="'signup.home.phoneLabel' | translate" [formGroup]="formGroup" />
              </div>
            }

            <div class="col-12 mb-3">
              @if(this.formGroup.get('isCompany')?.value) {
              <label for="companyEmail" class="form-label fw-semibold">
                {{ 'signup.home.companyEmailLabel' | translate }}
                <label class="text-danger">*</label>
              </label>
              <input type="email" formControlName="companyEmail" id="companyEmail" class="form-control"
                [placeholder]="'signup.home.companyEmailPlaceholder' | translate" />
              <field-error-component [field]="'companyEmail'" [label]="'signup.home.companyEmailLabel' | translate" [formGroup]="formGroup" />
              } @else {
              <label for="email" class="form-label fw-semibold">{{ 'signup.home.emailLabel' | translate }}</label>
              <input type="email" formControlName="email" id="email" class="form-control"
                [placeholder]="'signup.home.companyEmailPlaceholder' | translate" />
              <field-error-component [field]="'email'" [label]="'signup.home.emailLabel' | translate" [formGroup]="formGroup" />
              }
            </div>

            <div class="col-12 mb-3">
              <div class="col-12 mb-3">
                <label for="segment" class="form-label fw-semibold">
                  {{ 'signup.home.segmentLabel' | translate }}
                  <span class="text-danger">*</span>
                </label>

                <mat-select class="form-select" formControlName="segment">
                  <mat-option value="">{{ 'signup.home.selectSegment' | translate }}</mat-option>
                  @for (seg of segments; track $index) {
                  <mat-option [value]="seg">{{ seg }}</mat-option>
                  }
                </mat-select>

                <field-error-component [field]="'segment'" [label]="'signup.home.segmentLabel' | translate" [formGroup]="formGroup" />
              </div>

              @if (formGroup.get('segment')?.value === 'Outros') {
              <div class="col-12 mb-3">
                <label for="segmentOther" class="form-label fw-semibold">
                  {{ 'signup.home.segmentOtherLabel' | translate }}
                  <span class="text-danger">*</span>
                </label>
                <input type="text" formControlName="segmentOther" id="segmentOther" class="form-control"
                  [placeholder]="'signup.home.segmentOtherPlaceholder' | translate" />
                <field-error-component [field]="'segmentOther'" [label]="'signup.home.segmentLabel' | translate" [formGroup]="formGroup" />
              </div>
              }
            </div>

          </div>
          }

          @if (stepIndex() === 2) {
          <div class="row">
            <div class="col-6">
              <h5 class="mb-1">{{ 'signup.home.locationTitle' | translate }}</h5>
              <small class="text-muted">{{ 'signup.home.locationSubtitle' | translate }}</small>
            </div>
            @if (!!beeviralId) {
            <div class="col-6">
              <div class="alert alert-warning border-0 rounded-0 align-right" align="right" role="alert">
                <strong>TrendPartner</strong> por <strong>{{ beeviralId }}</strong>
              </div>
            </div>
            }
          </div>

          <div class="col-12 mb-3 mt-3">
            <label for="language" class="form-label fw-semibold">
              {{ 'signup.home.languageLabel' | translate }}
              <span class="text-danger">*</span>
            </label>
            <select id="language" class="form-control" formControlName="language" (change)="onLanguageChange($event)">
              @for (loc of locales; track loc) {
              <option [value]="loc">{{ localeLabels[loc] }}</option>
              }
            </select>
          </div>

          <div class="row mt-3">
            <div class="col-md-4 mb-3">
              <label for="zipCode" class="form-label fw-semibold">
                {{ 'signup.home.zipCodeLabel' | translate }}
                <span class="text-danger">*</span>
              </label>
              <input type="text" formControlName="zipCode" id="zipCode" class="form-control" placeholder="00.000-000"
                [mask]="'00.000-000'" />
              <field-error-component [field]="'zipCode'" [label]="'signup.home.zipCodeLabel' | translate" [formGroup]="formGroup" />
            </div>

            <div class="col-md-8 mb-3">
              <label for="street" class="form-label fw-semibold">
                {{ 'signup.home.streetLabel' | translate }}
                <span class="text-danger">*</span>
              </label>
              <input type="text" formControlName="street" id="street" class="form-control"
                [placeholder]="'signup.home.streetPlaceholder' | translate" />
              <field-error-component [field]="'street'" [label]="'signup.home.streetLabel' | translate" [formGroup]="formGroup" />
            </div>

            <div class="col-md-8 mb-3">
              <label for="city" class="form-label fw-semibold">
                {{ 'signup.home.cityLabel' | translate }}
                <span class="text-danger">*</span>
              </label>
              <input type="text" formControlName="city" id="city" class="form-control" [placeholder]="'signup.home.cityPlaceholder' | translate" />
              <field-error-component [field]="'city'" [label]="'signup.home.cityLabel' | translate" [formGroup]="formGroup" />
            </div>

            <div class="col-md-4 mb-3">
              <label for="state" class="form-label fw-semibold">
                {{ 'signup.home.stateLabel' | translate }}
                <span class="text-danger">*</span>
              </label>
              <select formControlName="state" id="state" class="form-control form-select">
                <option value="">{{ 'signup.home.selectOption' | translate }}</option>
                @for (st of states; track st.key) {
                <option [value]="st.key">{{ st.key }}</option>
                }
              </select>
              <field-error-component [field]="'state'" [label]="'signup.home.stateLabel' | translate" [formGroup]="formGroup" />
            </div>

            <div class="col-12 mb-3">
              <label for="complement" class="form-label fw-semibold">{{ 'signup.home.complementLabel' | translate }}</label>
              <input type="text" formControlName="complement" id="complement" class="form-control"
                [placeholder]="'signup.home.complementPlaceholder' | translate" />
            </div>
          </div>
          }

          @if (stepIndex() === 3) {
          <div class="row">
            <div class="col-6">
            <h5 class="mb-1">{{ 'signup.home.summaryTitle' | translate }}</h5>
            <small class="text-muted">{{ 'signup.home.summarySubtitle' | translate }}</small>
            </div>
            @if (!!beeviralId) {
            <div class="col-6">
              <div class="alert alert-warning border-0 rounded-0 align-right" align="right" role="alert">
                <strong>TrendPartner</strong> por <strong>{{ beeviralId }}</strong>
              </div>
            </div>
            }
          </div>

          <div class="mt-1">
            <div class="card">
              <div class="card-body">
                <div class="row g-1">
                  <div class="col-12 col-md-6">
                    <small class="text-muted">{{ 'signup.home.summaryName' | translate }} </small>
                    <strong>{{ formGroup.get('name')?.value }}</strong>
                  </div>
                  <div class="col-12 col-md-6">
                    <small class="text-muted">{{ 'signup.home.summaryEmail' | translate }} </small>
                    <strong>{{ formGroup.get('email')?.value }}</strong>
                  </div>
                  <div class="col-12 col-md-6">
                    <small class="text-muted">{{ 'signup.home.summaryCpf' | translate }} </small>
                    <strong>{{ formGroup.get('cpf')?.value }}</strong>
                  </div>
                  <div class="col-12 col-md-6">
                    <small class="text-muted">{{ 'signup.home.summaryPhone' | translate }} </small>
                    <strong>{{ formGroup.get('country')?.value }} {{ formGroup.get('phone')?.value }}</strong>
                  </div>

                  <div class="col-12">
                    <hr class="my-2" />
                  </div>

                  <div class="col-12 col-md-6">
                    <small class="text-muted">{{ 'signup.home.summaryRegisterAsCompany' | translate }} </small>
                    <strong>{{ formGroup.get('isCompany')?.value ? ('signup.home.yes' | translate) : ('signup.home.no' | translate) }}</strong>
                  </div>
                  <div class="col-12 col-md-6">
                    <small class="text-muted">
                      {{ formGroup.get('isCompany')?.value ? ('signup.home.companyNameLabel' | translate) : ('signup.home.nameLabel' | translate) }}
                    </small>
                    <strong>
                      {{ formGroup.get('isCompany')?.value ? formGroup.get('companyName')?.value :
                      formGroup.get('name')?.value }}
                    </strong>
                  </div>
                  <div class="col-12 col-md-6">
                    <small class="text-muted">
                      {{ formGroup.get('isCompany')?.value ? ('signup.home.cnpjLabel' | translate) : ('signup.home.cpfLabel' | translate) }}:
                    </small>
                    <strong>
                      {{ formGroup.get('isCompany')?.value ? (formGroup.get('cnpj')?.value || '-') :
                      formGroup.get('cpf')?.value }}
                    </strong>
                  </div>
                  <div class="col-12 col-md-6">
                    <small class="text-muted">
                      {{ formGroup.get('isCompany')?.value ? ('signup.home.companyEmailLabel' | translate) : ('signup.home.emailLabel' | translate) }}:
                    </small>
                    <strong>
                      {{ formGroup.get('isCompany')?.value ? formGroup.get('companyEmail')?.value :
                      formGroup.get('email')?.value }}
                    </strong>
                  </div>
                  <div class="col-12 col-md-6">
                    <small class="text-muted">
                      {{ formGroup.get('isCompany')?.value ? ('signup.home.companyPhoneLabel' | translate) : ('signup.home.phoneLabel' | translate) }}:
                    </small>
                    <strong>
                      {{ formGroup.get('isCompany')?.value ? formGroup.get('companyPhone')?.value :
                      formGroup.get('phone')?.value }}
                    </strong>
                  </div>
                  <div class="col-12 col-md-6">
                    <small class="text-muted">{{ 'signup.home.segmentLabel' | translate }}: </small>
                    <strong>
                      {{ formGroup.get('segment')?.value === 'Outros' ? formGroup.get('segmentOther')?.value :
                      formGroup.get('segment')?.value }}
                    </strong>
                  </div>

                  <div class="col-12">
                    <hr class="my-2" />
                  </div>

                  <div class="col-12 col-md-6">
                    <small class="text-muted">{{ 'signup.home.zipCodeLabel' | translate }}: </small>
                    <strong>{{ formGroup.get('zipCode')?.value }}</strong>
                  </div>
                  <div class="col-12 col-md-6">
                    <small class="text-muted">{{ 'signup.home.stateLabel' | translate }}: </small>
                    <strong>{{ formGroup.get('state')?.value }}</strong>
                  </div>
                  <div class="col-12 col-md-6">
                    <small class="text-muted">{{ 'signup.home.cityLabel' | translate }}: </small>
                    <strong>{{ formGroup.get('city')?.value }}</strong>
                  </div>
                  <div class="col-12 col-md-6">
                    <small class="text-muted">{{ 'signup.home.streetLabel' | translate }}: </small>
                    <strong>{{ formGroup.get('street')?.value }}</strong>
                  </div>
                  <div class="col-12">
                    <small class="text-muted">{{ 'signup.home.complementLabel' | translate }}: </small>
                    <strong>{{ formGroup.get('complement')?.value || '-' }}</strong>
                  </div>

                </div>
              </div>
            </div>
          </div>
          }

          @if (stepIndex() === 3) {
          <div class="recaptcha-container py-1">
            <div class="card">
              <div class="card-body py-1 text-center">
                <small class="text-muted d-block mb-2">
                  {{ 'signup.home.recaptchaMessage' | translate }}
                </small>

                <div class="d-flex justify-content-center">
                  <ngx-recaptcha2 formControlName="recaptcha" [siteKey]="recaptchaToken" [useGlobalDomain]="false">
                  </ngx-recaptcha2>
                </div>
              </div>
            </div>
          </div>
          }

          <div class="d-flex gap-2 justify-content-between mt-1">
            <button type="button" class="btn btn-outline-secondary d-flex align-items-center gap-2"
              [class.invisible]="stepIndex() === 0" (click)="previousStep()">
              <i class="mdi mdi-arrow-left-thin"></i>
              {{ 'signup.home.backButton' | translate }}
            </button>

            @if (stepIndex() < steps.length - 1) { <button type="button"
              class="btn btn-primary d-flex align-items-center gap-2" (click)="nextStep()">
              {{ 'signup.home.nextButton' | translate }}
              <i class="mdi mdi-arrow-right-thin"></i>
              </button>
              } @else {
              <button type="button" class="btn btn-success d-flex align-items-center gap-2"
                [disabled]="!formGroup.valid || !formGroup.get('recaptcha')?.value || loading"
                (click)="openConfirmCreate()">

                @if (!loading) {
                <i class="mdi mdi-check"></i>
                {{ 'signup.home.createCompanyButton' | translate }}
                } @else {
                <mat-spinner [diameter]="20" mode="indeterminate"></mat-spinner>
                }
              </button>
              }
          </div>


        </form>
      </div>
    </div>


    <div class="text-center w-100 mb-1">
      <span class="text-muted">{{ 'signup.home.alreadyHaveAccount' | translate }}</span>
      <a class="cursor-pointer ms-1" routerLink="/login">
        {{ 'signup.home.doLogin' | translate }}
      </a>
    </div>
    }

  </div>
</div>